export function thousandsSeparator(num) {
	const int = parseInt(num, 10);

	if (Number.isNaN(int)) {
		return num;
	}

	return int.toLocaleString('en-US', { minimumFractionDigits: 0 });
}
